import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store'
import { waitForStorageToBeReady } from '../utils'
import LandingPage from '../views/LandingPage'
import EditorPage from '../views/EditorPage'
import DesignsPage from '../views/DesignsPage'
import CartPage from '../views/CartPage'
import PaymentPage from '../views/PaymentPage'
import ThankYouPage from '../views/ThankYouPage'
import DesignMethodPage from '../views/DesignMethodPage'
import RequestOrderFormPage from '../views/RequestOrderFormPage'
import ChoosePlateMaterialPage from '../views/ChoosePlateMaterialPage'
import AboutUsPage from '../views/AboutUsPage'
import FaqPage from '../views/FaqPage'
import PrivacyPolicyPage from "@/views/PrivacyPolicyPage";
import TermsPage from '../views/TermsPage'
import TipsPage from '../views/TipsPage'
import PricingListPage from '../views/PricingListPage'

import ProductDetailPage from '../views/ProductDetailPage'
import RegisterPage from "@/views/RegisterPage";
import ChangePasswordPage from "@/views/ChangePasswordPage";
import RecoverPasswordPage from "@/views/RecoverPasswordPage";
import ProfilePage from "@/views/ProfilePage";
import PrintProofPage from "@/views/PrintProofPage";
import { trackRouter } from "vue-gtag-next"

var hash = location.hash

if (hash && hash.indexOf('#!') === 0) {
  location.hash = hash.slice(2)
}

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: LandingPage,
    },
    {
      path: '/:categorySlug',
      name: 'Category',
      component: LandingPage,
      props: true
    },
    {
      path: '/:productId/designmethod',
      name: 'DesignMethodPage',
      component: DesignMethodPage,
    },
    {
      path: '/:item/:productId/platematerial',
      name: 'ChoosePlateMaterialPage',
      component: ChoosePlateMaterialPage,
    },
    {
      path: '/:orderUuid/:requestUuid/:productId?/requestorderform',
      name: 'RequestOrderFormPage',
      component: RequestOrderFormPage,
      meta: { requiresAuth: true }
    },
    {
      path: '/product/:productSlug',
      name: 'ProductDetail',
      component: ProductDetailPage,
    },
    {
      path: '/:uuid/:item/:product/editor/',
      name: 'Editor',
      component: EditorPage,
      meta: { requiresAuth: true }
    },
    {
      path: '/account',
      name: 'Designs',
      component: DesignsPage,
      meta: { requiresAuth: true }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: ProfilePage,
      meta: { requiresAuth: true }
    },
    {
      path: '/changepassword',
      name: 'ChangePassword',
      component: ChangePasswordPage,
      meta: { requiresAuth: true }
    },
    {
      path: '/reset-password/:uid/:token/',
      name: 'RecoverPassword',
      component: RecoverPasswordPage
    },
    {
      path: '/:uuid/cart',
      name: 'Cart',
      component: CartPage,
      meta: { requiresAuth: true }
    },
    {
      path: '/:uuid/payment',
      name: 'PaymentPage',
      component: PaymentPage,
      meta: { requiresAuth: true }
    },
    {
      path: '/thanks',
      name: 'thanks',
      component: ThankYouPage,
      meta: { requiresAuth: true }
    },
    {
      path: '/about-us',
      name: 'AboutUs',
      component: AboutUsPage,
    },
    {
      path: '/faq',
      name: 'FaqPage',
      component: FaqPage,
    },
    {
      path: '/privacypolicy',
      name: 'PrivacyPolicyPage',
      component: PrivacyPolicyPage,
    },
    {
      path: '/terms',
      name: 'TermsPage',
      component: TermsPage,
    },
    {
      path: '/tips',
      name: 'TipsPage',
      component: TipsPage,
    },
    {
      path: '/pricing',
      name: 'PricingListPage',
      component: PricingListPage,
    },
    {
      path: '/register',
      name: 'RegisterPage',
      component: RegisterPage,
    },
    {
      path: '/print-proof/:token',
      name: 'PrintProof',
      component: PrintProofPage,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    document.getElementById('app').scrollIntoView();
  }
});

router.beforeEach(async (to, from, next) => {
  await waitForStorageToBeReady()
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.getToken) {
      next({
        path: '/'
      })
    } else {
      next()
    }
  } else {
    next()
  }
});

trackRouter(router);

export default router